import api from '@/api/index.js'

const account_deletion = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_DELETION_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_DELETION_UPDATING: (state, creating) => {
      state.updating = false;
    },
    SET_ACCOUNT_DELETION: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_DELETION_CREATED: (state, response) => {
      state.data = response;
      state.updating = false;
    },
    SET_ACCOUNT_DELETION_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    },
  },

  actions: {
    GetAccountDeletion({commit}, id) {
      commit('SET_ACCOUNT_DELETION_LOADING', true)
      commit('SET_ACCOUNT_DELETION_ERROR', null)
      return api.get(`accounts/${id}/deletion`)
        .then((response) => {
          commit('SET_ACCOUNT_DELETION', response)
          commit('SET_ACCOUNT_DELETION_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_DELETION_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_DELETION_LOADING', false)
        })
    },
    CreateAccountDeletion({dispatch, commit}, req) {
      commit('SET_ACCOUNT_DELETION_UPDATING', true)
      commit('SET_ACCOUNT_DELETION_ERROR', null)
      return api.post(`accounts/${req.accountID}/deletion`, {...req.payload})
        .then((response) => {
          commit('SET_ACCOUNT_DELETION_CREATED', response.body)
          commit('SET_ACCOUNT_DELETION_UPDATING', false)
          // dispatch('LoadAccount', req.accountID)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_DELETION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_DELETION_UPDATING', false)
        })
    },
    CancelAccountDeletion({dispatch, commit}, req) {
      commit('SET_ACCOUNT_DELETION_UPDATING', true)
      commit('SET_ACCOUNT_DELETION_ERROR', null)
      return api.put(`accounts/${req.accountID}/deletion`, req.payload)
        .then((response) => {
          commit('SET_ACCOUNT_DELETION_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_DELETION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_DELETION_UPDATING', false)
        })
    },
    DeleteAccount({dispatch, commit}, id) {
      commit('SET_ACCOUNT_DELETION_UPDATING', true)
      commit('SET_ACCOUNT_DELETION_ERROR', null)
      return api.delete(`accounts/${id}`)
        .then((response) => {
          commit('SET_ACCOUNT_DELETION_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_ACCOUNT_DELETION_UPDATING', false)
        })
    },
  },
}

export default account_deletion
